import React, {useEffect, useState} from "react";
import {Card, CardContent, CardHeader, CardTitle} from "../ui/Card";
import DataTable from "../DataTable";
import {siteColumn} from "../Columns";
import siteData from "../../data/siteData.json"

function Analysis() {
    const [data, setData] = useState([]);

    useEffect(() => {
        setData([])
        siteData.map(item => {
            setData((oldArray) => [...oldArray, item]);
        })
    }, [])

    return (
        <Card>
            <CardHeader>
                <CardTitle className="text-black">All Sites</CardTitle>
            </CardHeader>
            <CardContent>
                <DataTable columns={siteColumn} data={data} />
            </CardContent>
        </Card>
    )
}

export default Analysis